
import LoadSimple from "../../LoadSimple";
import Modal from 'react-modal';
import ModalDeleteTech from "./ModalDeleteTech";
import { useState, useEffect } from "react";
import { capitalizeFirstLetter } from "../../../utils/utils";
import { lang } from "../../generales/traduction";
const deleteUserModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    background: '#ffffff !important',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width:'30%',
    height:'20%',
    padding:'20px'
  },
};
const AuditorList = ({
  pageActual,
  limitList,startLimit,
  dataList,
  devices,
  handleChangEdit,
  setData,
  setRegisterIsValid,
  setLoading,
  setError,
  server,
  dataUsers,
  setDataUsers,
  searchResults,
  setSearchResults,
  searchTerm,
  setSearchTerm,
  cisSelected,
  setCisSelected,
  languaje,
  mode,
  rowSelected,
  poolRows,
  handleShowPopup,
  buscar_cis,
  loadingList
}) => {
  const [deleteUserModalOpen, setDeleteUserModalOpen] =useState(false);
  const [userSelected,setUserSelected]=useState({})
  function openDeleteUserModal() {
    setDeleteUserModalOpen(true);
  }

  function closDeleteUserModal() {
    setSearchTerm("")
    setDeleteUserModalOpen(false);
  }
  const handledeleteUserClick = (data) => {
        
    openDeleteUserModal()
    setUserSelected(data)
    // Realiza las acciones deseadas al hacer clic en el marcador
  };
  useEffect(() => {
    buscar_cis();
  }, []);
  // const buscar_cis = () => {
  //   // setLoadingCis(true)
  //   const data={
  //     start_date :'2024-01-01T00:00:00',
  //     end_date :'2024-12-31T23:59:59',
  //     user_email:'',
  //     module_id:''
  //   }
  //   const fetchDataPost = async () => {
  //     try {
  //       let baseURL=''
  //       baseURL = server.url+'/api/v1/cassia/audit/';
  //       const start_date  = '?start_date='+data.start_date
  //       const end_date = '&end_date='+data.end_date
  //       const user_email = (data.user_email=="")?'':'&user_email='+data.user_email
  //       const module_id = (data.module_id=="")?'':'&user_email='+data.module_id

  //       const url=baseURL+start_date+end_date+user_email+module_id
  //       // console.log(url)  
  //       const response = await fetch(
  //         url,
  //         {
  //           method: "GET",
  //           headers: {
  //             "Content-Type": "application/json",
  //             accept: "application/json",
  //             Authorization: `Bearer ${localStorage.getItem("access_token")}`,
  //           },
  //         }
  //       );

  //       console.log(response);
  //       if (response.ok) {
  //         const data1 = await response.json();
  //         // setLoadingCis(false)
  //         console.log(data1);
  //         setDataUsers(data1);
  //         // setCreateCisModalOpen(true)
  //       } else {
  //         const data1 = await response.json();
  //         console.log(data1);
  //         throw new Error("Error en la solicitud");
  //       }
  //     } catch (error) {
  //       console.error(error);
  //     }
  //   };

  //   fetchDataPost();
  // };

  const cisSelectRow = (elemento) => {
    setCisSelected(elemento);
  };

  return (
    <>
      <div className="cont-row-user-list">
        {loadingList ? (
          <div className="cont-load-user-list">
            <LoadSimple></LoadSimple>
          </div>
        ) : (
          dataList
            .slice(startLimit, parseInt(pageActual) * parseInt(limitList))
            .map((elemento, indice) => (
              <div
                className={"row-table-portafolio"+mode}
                key={indice}
                style={{height:'60px !important'}}
              >
                 
                <div className="field-body-table-mantenimiento field-larger" style={{width:'22%'}}>
                  {elemento.host}
                </div>
                <div className="field-body-table-mantenimiento field-larger" >
                  {elemento.ip}
                </div>
                <div className="field-body-table-mantenimiento field-larger" >
                  {elemento.task_type}
                </div>
                <div className="field-body-table-mantenimiento field-larger" >
                  {elemento.softwarekey}
                </div>
                <div className="field-body-table-mantenimiento field-larger" style={{width:'40%'}} >
                  {elemento.error_message}
                </div>
                <div className="field-body-table-mantenimiento field-larger" >
                  {elemento.created_at}
                </div>
                
                <div className="field-body-table-mantenimiento field-larger" >
                  {elemento.updated_at}
                </div>
                <div className="field-body-table-mantenimiento field-larger" style={{color:elemento.status=='error'?'red':'green'}} >
                  {elemento.status.toUpperCase()}
                </div>
              </div>
            ))
        )}
        { dataList.length == 0  && loadingList==false ? (
          <div className="no-results">{capitalizeFirstLetter(lang[languaje]['sinResultados'])}.</div>
        ) : (
          ""
        )}
      </div>
      <Modal
        isOpen={deleteUserModalOpen}
        // isOpen={true}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closDeleteUserModal}
        style={deleteUserModalStyles}
        contentLabel="Example Modal2"
        // shouldCloseOnOverlayClick={false}
        >
          <ModalDeleteTech handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} buscar_cis={buscar_cis} server={server} setData={setData} setLoading={setLoading} setError={setError} user={userSelected} closDeleteUserModal={closDeleteUserModal}></ModalDeleteTech>
    </Modal>
    </>
  );
};

export default AuditorList;
